// Human-friendly remaining time until an ISO deadline (e.g. "2 j 3 h", "5 h 20 min", "40 min").
export function fmtRemaining(deadlineIso) {
  if (!deadlineIso) return '';
  const ms = new Date(deadlineIso).getTime() - Date.now();
  if (ms <= 0) return '';
  const mins = Math.floor(ms / 60000);
  const days = Math.floor(mins / 1440);
  const hours = Math.floor((mins % 1440) / 60);
  const m = mins % 60;
  if (days > 0) return `${days} j ${hours} h`;
  if (hours > 0) return `${hours} h ${m} min`;
  return `${m} min`;
}
